import { render, staticRenderFns } from "./blessReward.vue?vue&type=template&id=01f82db2&scoped=true&"
import script from "./blessReward.vue?vue&type=script&lang=js&"
export * from "./blessReward.vue?vue&type=script&lang=js&"
import style0 from "./blessReward.vue?vue&type=style&index=0&lang=css&"
import style1 from "./blessReward.vue?vue&type=style&index=1&id=01f82db2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f82db2",
  null
  
)

component.options.__file = "blessReward.vue"
export default component.exports